var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.243,
    height: 64.243,
    viewBox: "0 0 64.243 64.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.379 -447.379)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 58,
    x2: 58,
    transform: "translate(74.5 451.5)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.78 460.441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1002.765,958.95c-7.274,0-18.814-6.745-18.814-24.844,0-11.855,6.308-24.455,18-24.455.5,0,1.021.03,1.551.069a14.989,14.989,0,0,1,6.5,2.707c.334.209.667.416,1,.616,6.619,3.968,9.583,13.381,9.583,20.951a35.225,35.225,0,0,1-3.821,15.618C1013.483,955.722,1008.645,958.95,1002.765,958.95Zm-.815-46.236c-9.7,0-14.936,11.022-14.936,21.392,0,15.867,9.662,21.781,15.752,21.781,11.145,0,14.75-14.75,14.75-21.893,0-6.488-2.534-14.992-8.1-18.326-.35-.21-.7-.426-1.044-.643a12.341,12.341,0,0,0-5.115-2.251C1002.811,912.741,1002.371,912.714,1001.95,912.714Z",
    transform: "translate(-983.951 -909.651)",
    fill: "#e5b515"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23338.2,8229.044h-.006a14.25,14.25,0,0,1-6.287-1.487,15.268,15.268,0,0,1-4.812-3.835,18.963,18.963,0,0,1-3.623-6.55,22.351,22.351,0,0,1-.91-9,34.241,34.241,0,0,1,11.947-22.175,19.038,19.038,0,0,1,11.787-4.632,14.707,14.707,0,0,1,6.49,1.525c.418.208.877.459,1.361.745a14.944,14.944,0,0,1,4.648,5.27l.006.012c.211.343.428.68.629.992.15.236.295.473.428.7a14.43,14.43,0,0,0-2.9,1.115l-.027-.043-.025-.043c-.014-.019-.027-.038-.039-.057l0-.008c-.135-.2-.26-.4-.395-.617l-.059-.1c-.027-.042-.053-.083-.08-.125-.041-.066-.082-.133-.125-.2l-.012-.019a12.332,12.332,0,0,0-3.6-4.247c-.369-.212-.764-.436-1.15-.628a11.7,11.7,0,0,0-5.164-1.208c-3.342,0-6.838,1.429-10.107,4.133a29.826,29.826,0,0,0-7.531,9.756c-2.148,4.4-4.3,11.031-2.355,17.588a15.92,15.92,0,0,0,2.957,5.636,12.323,12.323,0,0,0,4.01,3.26,11.147,11.147,0,0,0,4.92,1.162,14.684,14.684,0,0,0,8.49-3.085,27.693,27.693,0,0,0,.939,3.085A17.171,17.171,0,0,1,23338.2,8229.044Z",
    transform: "translate(-23246.953 -7729.676)",
    fill: "#e5b515",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 58,
    x2: 58,
    transform: "translate(72.5 449.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggIcon);
export default __webpack_public_path__ + "static/media/egg-icon.908612aa.svg";
export { ForwardRef as ReactComponent };